"use client";

import React from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import { FontIcon, Switch } from "@/app/_components";
import styles from "./SettingsDialog.module.css";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";

interface SettingsDialogProps extends SDialogProps {}

export const SettingsDialogFC: React.FC<SettingsDialogProps> = (props) => {
    const { fcKey, onClose } = props;
    const {closeDialog} = useDialogMethods(fcKey);

    const onClick = () => {
        onClose?.();
        closeDialog();
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            title=""
        >
            <section className={styles.layer}>
                <section className={styles.settings_wrapper} onClick={onClick}>
                    <section className={styles.content} onClick={(e) => e.stopPropagation()}>
                        <section className={styles.close} onClick={onClick}>
                            <FontIcon icon="s-fail" style={{ fontSize: ".2rem" }} />
                        </section>
                        <section className={styles.item}>
                            <div>
                                <FontIcon style={{ fontSize: ".25rem", verticalAlign: "sub", marginRight: ".16rem" }} icon="s-music" />
                                Music
                            </div>
                            <div>
                                <Switch style={{
                                    //@ts-ignore
                                    "--width": ".67rem",
                                    "--height": ".33rem"
                                }} />
                            </div>
                        </section>
                        <section className={styles.item}>
                            <div>
                                <FontIcon style={{ fontSize: ".25rem", verticalAlign: "sub", marginRight: ".16rem" }} icon="s-ring" />
                                Sound
                            </div>
                            <div>
                                <Switch style={{
                                    //@ts-ignore
                                    "--width": ".67rem",
                                    "--height": ".33rem" }}
                                />
                            </div>
                        </section>
                        <section className={styles.item}>
                            <div>
                                <FontIcon style={{ fontSize: ".25rem", verticalAlign: "sub", marginRight: ".16rem" }} icon="s-shock" />
                                Vibration
                            </div>
                            <div>
                                <Switch style={{
                                    //@ts-ignore
                                    "--width": ".67rem",
                                    "--height": ".33rem" }}
                                />
                            </div>
                        </section>
                        <section className={styles.item}>
                            <div>
                                <FontIcon style={{ fontSize: ".25rem", verticalAlign: "bottom", marginRight: "1rem" }} icon="s-form" />
                                PayTable
                            </div>
                        </section>
                    </section>
                </section>
            </section>
        </SDialogFC>
    );
};
